import { Appearance } from '@stripe/stripe-js';
import { Palette } from '@infoods/lifebase-ui';

export const getStripeElementsAppearance = (palette: Palette): Appearance => ({
  variables: {
    fontFamily: 'Lato, sans-serif',
    colorPrimary: palette.primary['500'],
    fontSizeBase: '16px',
    borderRadius: '5px',
    colorText: palette.mainBlack,
    colorTextPlaceholder: palette.natural['600'],
  },
});
